import React, { useState } from "react";
import styled from "styled-components";
import Button from "sushiweb/Button";
import Input from "sushiweb/InputTypes/Input";
import Textarea from "sushiweb/InputTypes/Textarea";
import { BottomSectionModal } from "../../constants/assets/containers";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";
import { filterObj, isObjectAllEntriesPresent } from "../../utils";
import { useHistory } from "react-router";
import NoFooterModal from "../Common/NoFooterModal";
import { getCookie } from "../../services/config/storage";

// Config variables
const CLIENT_URL = process.env.REACT_APP__SHEETS_CLIENT_URL;

const dropOutReasons = [
  "Missing field/entity",
  "Bad UX (couldnt find what I am looking for)",
  "UI not consistent/not working",
  "Other",
];

const FeedbackForm = ({ onSubmit, handleClose }) => {
  const [initialState, setInitialState] = useState({
    Email: "",
    Origin: "",
    Dashboard: "",
    Roles: "",
    Reason: "",
    Remarks: "",
  });

  const history = useHistory();

  const checkValidations = () => {
    const body = filterObj(initialState, ["Email", "Reason", "Remarks"]);
    return !isObjectAllEntriesPresent(body);
  };

  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const handleSubmit = async () => {
    const values = { ...initialState };
    values["Origin"] = window.location.origin;
    values["Dashboard"] = history.location.pathname;
    values["Roles"] = getCookie("user_roles")
      ? getCookie("user_roles").split("&").join(",")
      : "NA";
    fetch(CLIENT_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(values),
    }).then(() => handleClose());
    onSubmit();
  };

  const handleSkip = async () => {
    handleClose();
    onSubmit();
  };

  return (
    <FeedbackFormContainer id="feedbackFormFormModal">
      <NoFooterModal
        header={true}
        heading="Give feedback"
        handleClose={handleClose}
        modalButtons={
          <BottomSectionModal className="flex items-center justify-between">
            <Button
              data-testid="saveButton"
              disabled={checkValidations()}
              onClick={handleSubmit}
              className="sushi-btn"
            >
              Save & Proceed
            </Button>
            <Button
              data-testid="skipButton"
              onClick={handleSkip}
              className="sushi-btn"
            >
              Skip & Proceed
            </Button>
          </BottomSectionModal>
        }
      >
        <h4 className="medium">
          Please give your valuable feedback here before moving to old
          dashboard. It will help us further improve the new dashboard. Thanks!
        </h4>
        <form name="feedback-form">
          <Input
            value={initialState.Email}
            data-testid="userEmail"
            onChange={(e) => handleChange("Email", e)}
            id="sushi-input"
            label="Enter your Zomato email"
          />
          <PaginatedReactDropdown
            options={dropOutReasons}
            labelWidth="10%"
            value={initialState.Reason}
            handleChange={handleChange}
            keyToChange="Reason"
            placeholder="Reason"
            showCross={false}
            id="dropoutReasonsDropdown"
          />
          <Textarea
            id="sushi-textarea"
            data-testid="userRemarks"
            className="mb-10"
            fullWidth={true}
            label="Remarks"
            onChange={(e) => handleChange("Remarks", e)}
            value={initialState.Remarks}
          />
        </form>
      </NoFooterModal>
    </FeedbackFormContainer>
  );
};

const FeedbackFormContainer = styled.section``;

export default FeedbackForm;
